<div class="protect-light-package" (click)="showHideExtendedPart()">
  <span class="protect-light-package-img-span">
    <img class="protect-light-package-img" src="./assets/injury-plaster.png" alt="">
  </span>
  <span class="protect-light-package-title">COMFORT</span>
  <span class="protect-light-package-icon-span">
    <nx-icon name="plus-circle" class="white" size="s" aria-hidden="true"></nx-icon>
  </span>
</div>
@if (isExtendedPartActive) {
  <div class="protect-light-package-extended-part">
    <ul class="protect-light-package-extended-part-description">
      <li (click)="isLongTermLossOfEmploymentByAccidentClicked = !isLongTermLossOfEmploymentByAccidentClicked">Трайно намалена работоспособност над 70% в резултат на злополука</li>
      @if (isLongTermLossOfEmploymentByAccidentClicked) {
        <div> Изплаща се процент от застрахователната сума, равен на процента трайно намалена работоспособност определен от Териториалната експертна лекарска комисия (ТЕЛК). </div>
      }
      <li (click)="isDeathClicked = !isDeathClicked">Смърт в резултат на злополука</li>
      @if (isDeathClicked) {
        <div> На ползващите лица се изплаща договорената застрахователна сума в <b>двоен размер</b>.</div>
      }
    </ul>
    @if (!hideIllnessWhenOver65Years) {
      <div class="protect-light-package-extended-part-checkbox-div">
        <span class="protect-light-package-extended-part-checkbox">
          <div [ngClass]="{'is-checked':isCrillAndSecMedOPChecked}" class="custom-checkbox-div">
            @if (isCrillAndSecMedOPChecked) {
              <nx-icon name="check" class="white" size="s" aria-hidden="true"></nx-icon>
            }
          </div>
          <input class="custom-checkbox" [(ngModel)]="isCrillAndSecMedOPChecked" (click)="onCheckboxClick()" type="checkbox" />
        </span>
        <span class="protect-light-package-extended-part-text clearfix" (click)="isAddDiseaseAndSecondOpinionClicked = !isAddDiseaseAndSecondOpinionClicked">ДОБАВИ ТЕЖКИ ЗАБОЛЯВАНИЯ И ВТОРО МЕДИЦИНСКО МНЕНИЕ</span>
        @if (isAddDiseaseAndSecondOpinionClicked) {
          <div>
            <div class="checkboxesGroup3-light">
              <div class="checkboxesGroup3-text-light" (click)="showHideCrillDescription()">ТЕЖКИ ЗАБОЛЯВАНИЯ</div>
              @if (isCrillDescriptionActive) {
                <div class="crill-info-container">
                  <ul>
                    <li>Доброкачествен тумор на мозъка</li>
                    <li>Слепота</li>
                    <li>Кома</li>
                    <li>Аорто-коронарни байпас графтове</li>
                    <li>Сърдечен удар</li>
                    <li>Бъбречна недостатъчност</li>
                    <li>Животозастрашаващ рак</li>
                    <li>Загуба на слух</li>
                    <li>Загуба на говор</li>
                    <li>Трансплантация на органи</li>
                    <li>Парализа/Инсулт</li>
                    <li>Тежки изгаряния</li>
                  </ul>
                </div>
              }
              <div class="checkboxesGroup3-text-light" (click)="showHideSecondMedicalOpinionDescription()">ВТОРО МЕДИЦИНСКО МНЕНИЕ </div>
              @if (isSecondMedicalOpinionDescriptionActive) {
                <div class="crill-info-container">
                  При диагностициране на заболяване неизискващо спешно лечение, получавате експертна препоръка за най-подходящото лечение от
                  водещи световни специалисти: Услугата включва:
                  <ul>
                    <li>Заявяване към MediGuide ползването на второ медицинско мнение</li>
                    <li>Водещи световни медицински клиники</li>
                    <li>Избор на клиниката, от която искате да получите второто медицинско мнение</li>
                    <li>В срок от 10 работни дни получавате доклад за първоначалната диагноза и предложен план за лечение</li>
                  </ul>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
    <div class="text-align-center">
      <button type="button" class="protect-light-package-extended-part-button" (click)="calculate()">
        <span class="protect-light-package-extended-part-button-text"> ИЗЧИСЛИ СВОЯТА ВНОСКА </span>
      </button>
      <div class="protect-light-package-extended-part-button-error-text">
        @if (isThereEmptyField) {
          <small>Всички полета са задължителни! <br> Моля попълнете празните полета в текста по-горе!</small>
        }
        @if (!isBornDateCharactersCorrect) {
          <small>Годината Ви на раждане трябва да съдържа само цифри и точки!</small>
        }
        @if (!isBornDateMonthAndDayCorrect) {
          <small>Годината Ви на раждане съдържа невалиден месец или ден!</small>
        }
        @if (!isBornDateLengthCorrect) {
          <small>Годината Ви на раждане трябва да съдържа 10 символа!</small>
        }
        @if (!isBornDateCorrect) {
          <small>Вашата възраст трябва да бъде между 14 и 60г. <br> и не повече от 70г. в края на програмата.</small>
        }
        @if (!isYearsOfDurationCorrect) {
          <small>Периодът трябва да бъде между 10 и 30 години.</small>
        }
      </div>
    </div>
  </div>
}